import React, { useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Fade from "@material-ui/core/Fade";
import { withStyles } from "@material-ui/core/styles";
import ManufacturerSelect from "./ManufacturerSelect";
import manufacturers from "./manufacturers";
import PolicyBadges from "./PolicyBadges";
import getManufacturerComponents from "./getManufacturerComponents";

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#fff",
    color: "#25265e",
    maxWidth: "150px",
    fontSize: "12px",
    border: "1px solid #dadde9",
    boxShadow: "0 6px 14px 0 rgba(76, 84, 153, 0.2)",
    borderRadius: "8px",
  },
}))(Tooltip);

const ContractedPharmaciesTable = (props) => {
  const manufacturerInfo = manufacturers.map((manufacturer) => ({
    value: manufacturer.value,
    label: props.manufacturerNames[manufacturer.value],
    policies: manufacturer.policies,
  }));
  const [selectedManufacturer, setSelectedManufacturer] = useState(manufacturerInfo[0]);
  const [isDesignationsModalOpen, setIsDesignationsModalOpen] = useState(false);

  const { PharmacyTable, DesignationsForm, additionalProps } = getManufacturerComponents(
    selectedManufacturer.value.toLowerCase(),
    props
  );

  const pharmacyTableProps = {
    entity: props.entity,
    pharmacies: props.entity.pharmacies,
    entity_designations_status: props.entity_designations_status,
    designations_path: props.designations_path,
    ...additionalProps,
  };

  const getPolicyLink = (manufacturer, policyType, filename) => {
    return `/resources/${manufacturer}/${policyType}/${filename}`;
  };

  const POLICY_TYPES = [
    { key: "in_house", label: "In-House" },
    { key: "contract_pharmacy", label: "CP" },
    { key: "all_claims", label: "All Claims" },
  ];

  const renderPolicyButtons = () => {
    const policyTypes = props.manufacturers_policy_types[selectedManufacturer.value];
    if (!policyTypes) return null;

    const visibleTypes = POLICY_TYPES.filter((type) => Object.keys(policyTypes).includes(type.key));
    visibleTypes.forEach((policy) => {
      policy.filename = policyTypes[policy.key];
    });
    const hasMultipleTypes = visibleTypes.length > 1;

    return (
      <>
        {visibleTypes.map(({ key, label, filename }) => (
          <a
            href={getPolicyLink(selectedManufacturer.value, key, filename)}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--sm btn--white details__header__policy-button"
          >
            {hasMultipleTypes ? `View ${label} Policy` : "View Policy"}
          </a>
        ))}
      </>
    );
  };
  const allManufacturersSelected = selectedManufacturer.value === "all";

  const renderDesignationsButton = () => (
    <button
      className={`btn btn--sm details__header__designations-button ${allManufacturersSelected ? "btn--disabled" : ""}`}
      onClick={() => {
        setIsDesignationsModalOpen(!isDesignationsModalOpen);
      }}
      disabled={allManufacturersSelected}
    >
      Make Designations
    </button>
  );

  const manufacturer = manufacturerInfo.find(({ value }) => value === selectedManufacturer.value);

  return (
    <>
      <div className="details__header__tab_bar">
        <ManufacturerSelect
          manufacturers={manufacturerInfo}
          selectedManufacturer={selectedManufacturer}
          setSelectedManufacturer={setSelectedManufacturer}
        />
        <div className="details__header__tab_bar__badges">
          <div className="details__header__tab_bar__badges__label">Policies</div>
          <div className="details__header__tab_bar__badges__content">
            {allManufacturersSelected ? (
              <p className="details__header__tab_bar__badges__instruction">
                Select a Manufacturer to view their policies
              </p>
            ) : (
              <PolicyBadges manufacturer={manufacturer} />
            )}
          </div>
        </div>
        <div className="details__header__tab_bar__button">
          {allManufacturersSelected ? (
            <CustomTooltip
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 350 }}
              placement="top"
              title="Select a manufacturer to make designations."
            >
              <span>{renderDesignationsButton()}</span>
            </CustomTooltip>
          ) : (
            <div className="details__header__button-container">
              {renderPolicyButtons()}
              {renderDesignationsButton()}
            </div>
          )}
        </div>
      </div>
      <PharmacyTable {...pharmacyTableProps} />
      {DesignationsForm && (
        <DesignationsForm
          {...props}
          isOpen={isDesignationsModalOpen}
          setIsOpen={setIsDesignationsModalOpen}
          vanityManufacturerName={props.manufacturerNames[selectedManufacturer.value]}
        />
      )}
    </>
  );
};

export default ContractedPharmaciesTable;
